// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@guestsupply/App/Components/Cart/LinesHeader";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: 91px 3fr 1.5fr 1fr 1.5fr 22px;
        grid-column-gap: 12px;
        grid-auto-flow: column;
        padding: 0 12px;
        color: ${color("text.main")};
        background: ${color("common.ui2")};
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 15px;
        width: 100%;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;

        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            padding: 0;
            ${({ hideOnTablet }: any) => hideOnTablet && "display: none;"}
        }
    `,
};
linesHeaderStyles.topSectionBorderStyles = {
    css: css`
        ${xScreen("lte", "md")} {
            border-top: 1px solid ${getColor("common.border")};
        }
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        grid-column: 1 / 3;
        padding: 8px 0;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            grid-column: 1 / 7;
            border-right: none;
            padding: 8px 12px;
            border-bottom: 1px solid ${color("common.border")};
        }
        ${xScreen("lte", "sm")} {
            border-bottom: none;
            padding: 6px 12px;
        }
    `,
};

linesHeaderStyles.priceUnit = {
    css: css`
        grid-column: 3 / 4;
        padding: 8px 0;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            padding-left: 12px;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 7;
            border-right: none;
            padding: 6px 12px;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        grid-column: 4 / 5;
        border-right: 1px solid ${color("common.border")};
        padding: 8px 0;
        ${xScreen("lte", "md")} {
            grid-column: 3 / 5;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 7;
            border-right: none;
            padding: 6px 12px;
        }
    `,
};
linesHeaderStyles.total = {
    css: css`
        grid-column: 5 / 6;
        padding: 8px 0;
        ${xScreen("lte", "md")} {
            grid-column: 5 / 7;
            padding-right: 12px;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 7;
            border-right: none;
            padding: 6px 12px;
        }
    `,
};
